var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Widget', [_c('WidgetBody', [_c('form', {
    ref: "form",
    staticClass: "grid grid-cols-1 gap-2 w-2/5",
    attrs: {
      "id": "create-campaign",
      "name": "create-campaign"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.createNewCampaign.apply(null, arguments);
      }
    }
  }, [_c('YInput', {
    attrs: {
      "label": "Campaign Name"
    },
    model: {
      value: _vm.campaignName,
      callback: function ($$v) {
        _vm.campaignName = $$v;
      },
      expression: "campaignName"
    }
  }), _c('Superselect', {
    attrs: {
      "title": "Show Front-end",
      "multiple": false,
      "placeholder": "Select",
      "options": ['All In Affiliates', 'yTrack']
    },
    model: {
      value: _vm.showFrontend,
      callback: function ($$v) {
        _vm.showFrontend = $$v;
      },
      expression: "showFrontend"
    }
  }), _c('Superselect', {
    attrs: {
      "title": "Payout Type",
      "multiple": false,
      "placeholder": "Select",
      "options": _vm.introspectionType
    },
    model: {
      value: _vm.payoutType,
      callback: function ($$v) {
        _vm.payoutType = $$v;
      },
      expression: "payoutType"
    }
  }), _c('div', {
    staticClass: "mt-4"
  }, [_c('YButton', {
    attrs: {
      "color": "blue",
      "type": "submit",
      "isLoading": _vm.isCreating
    }
  }, [_vm._v("Create Campaign")])], 1)], 1)])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }